<template>
  <div class="home">
    <home-banner></home-banner>
    <div class="home-container flex-center">
      <home-sys class="home-sys" @handleClick="enterSys"></home-sys>
      <div class="home-title">产品服务</div>
      <div class="home-title-border"></div>
      <div class="home-service">
        <div class="home-service-item" v-for="item in serviceData" :key="item.name" span="8" @click="showWarning">
          <home-card :render="item"></home-card>
        </div>
      </div>
      <div class="home-service-more-btn" @click="knowMore">了解更多</div>
      <div class="home-title">入驻流程</div>
      <div class="home-title-border"></div>
      <div class="home-progress-pre">哔哩哔哩开放平台提供丰富的内容生产、监控等能力，满足更多场景下的需求，快来加入我们吧！</div>
      <home-process class="home-process" @handleClick="enterCompanyAdd"></home-process>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/home/Banner'
import Sys from '@/components/home/Sys'
import Card from '@/components/Card'
import Process from '@/components/home/Process'
import VideoIcon from '@/assets/icon/video_3.png'
import CardIcon from '@/assets/icon/card_3.png'
import CloudIcon from '@/assets/icon/cloud_3.png'
import VideoIconLottie from '@/components/lottie/video_icon_lottie'
import CardIconLottie from '@/components/lottie/card_icon_lottie'
import CloudIconLottie from '@/components/lottie/cloud_icon_lottie'

export default {
  name: 'home',
  components: {
    'home-banner': Banner,
    'home-sys': Sys,
    'home-card': Card,
    'home-process': Process
  },
  data: () => {
    return {
      serviceData: [
        {
          title: '业务开放',
          content: '提供内容分发、数据回流、用户管理等功能，形成内容闭环',
          icon: VideoIcon,
          lottieData: VideoIconLottie
        },
        {
          title: '解决方案',
          content: '为up主和服务商，提供丰富的行业定制化解决方案',
          icon: CardIcon,
          lottieData: CardIconLottie
        },
        {
          title: '服务支持',
          content: '提供测试环境，丰富并完善用户对接流程',
          icon: CloudIcon,
          lottieData: CloudIconLottie
        }
      ]
    }
  },
  mounted() {
    this.$LogReport.sendCustomEvent('openplat_home_page_load')
  },
  methods: {
    enterSys(sys_id) {
      if (sys_id === 'all') {
        this.$LogReport.sendCustomEvent('openplat_morenotice_click')
        this.$router.push({ name: 'sys' })
      } else {
        this.$LogReport.sendCustomEvent('openplat_notice_click', {sys_id})
        this.$router.push({ name: 'sysDetail', params: { sys_id } })
      }
    },
    enterCompanyAdd() {
      this.$LogReport.sendCustomEvent('openplat_applyin_click')
      if (this.$store.state.userInfo && !this.$store.state.companyInfo) {
        this.$bus.$emit('showCompanyDialog', true)
      } else {
        this.$router.push({ name: 'companyAdd' })
      }
    },
    knowMore() {
      this.$LogReport.sendCustomEvent('openplat_productservice_getmore_click')
      this.$router.push({ name: 'doc' })
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  display: flex;
  align-items: center;
  // justify-content: center;
  flex-direction: column;
  position: relative;
  &-title {
    font-size: 28px;
    color: #222222;
    line-height: 32px;
    font-weight: 600;
    margin-top: 50px;
    text-align: center;
    &-border {
      background-image: linear-gradient(270deg, #ffffff 0%, #cccccc 100%);
      width: 54px;
      height: 4px;
      margin-top: 8px;
      margin-bottom: 18px;
    }
  }
  &-container {
    width: calc(100% - 80px);
    margin: 0 20px;
    padding: 0;
    flex-direction: column;
  }
  &-service {
    max-width: 1440px;
    display: flex;
    &-item {
      flex: 1;
      padding: 0 16px;
    }
    &-item:first-child {
      padding-left: 0px;
    }
    &-item:last-child {
      padding-right: 0px;
    }
  }
  .home-service-more-btn {
    width: 144px;
    height: 44px;
    line-height: 44px;
    background-color: #04a2d6;
    color: #ffffff;
    text-align: center;
    font-weight: 600;
    margin: 30px auto;
    cursor: pointer;
  }
  &-sys {
    margin-top: 28px;
  }
  &-card {
    max-width: 1440px;
  }
  .home-progress-pre {
    font-size: 16px;
    color: #999999;
    text-align: center;
    line-height: 16px;
    font-weight: 400;
    padding: 24px 0 44px;
  }
  &-process {
    margin-bottom: 93px;
  }
}
</style>
